import { render, staticRenderFns } from "./MessageForm.vue?vue&type=template&id=95ec5cea&scoped=true"
import script from "./MessageForm.vue?vue&type=script&lang=js"
export * from "./MessageForm.vue?vue&type=script&lang=js"
import style0 from "./MessageForm.vue?vue&type=style&index=0&id=95ec5cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ec5cea",
  null
  
)

export default component.exports